<template>
  <div class="header-wrap">
    <el-container>
      <div class="header-logo">
        <img style="width: 100%; height: 100%;" src="../../assets/img/m-logo.jpg" alt="">
      </div>
      <el-container class="header-left">
        <el-tooltip class="item" effect="dark" content="业务人员信息记录管理和报告业绩查询统计" placement="bottom-start">
          <div class="header-item" @click="toPage('salesman')" :class="thisPath === '/salesman/salesman' ? 'header-opt' : ''">业务人员管理与报告业绩统计</div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="报告消费记录查询和业务人员报告业绩查询" placement="bottom">
          <div class="header-item" @click="toPage('appBuyInfo')" :class="thisPath === '/appUser/appBuyInfo' ? 'header-opt' : ''">报告消费明细表与业绩查询</div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="专家服务消费记录查询" placement="bottom">
          <div class="header-item" @click="toPage('expertBuyInfo')" :class="thisPath === '/expert/expertBuyInfo' ? 'header-opt' : ''">专家服务消费明细表</div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="用户账户注册信息查询" placement="bottom">
          <div class="header-item" @click="toPage('appUser')" :class="thisPath === '/appUser/appUser' ? 'header-opt' : ''">用户列表查询</div>
        </el-tooltip>
      </el-container>
      <div class="header-right">
        <div><span>管理员：</span>{{userName}}</div>
        <el-dropdown class="header-right-text" @command="changeOpt">
          <i class="el-icon-setting header-icon"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">账户管理</el-dropdown-item>
            <el-dropdown-item :command="2">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      userName: '',
      thisPath: ''
    }
  },
  methods: {
    changeOpt (e) {
      console.log(e)
      if (e === 1) {
        this.$router.push({name: 'account'})
      }
      if (e === 2) {
        this.logout()
      }
    },
    toPage (path) {
      this.$router.push({name: path})
    },
    logout () {
      let _this = this
      this.$messageBox.confirm('您确定要退出平台?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$router.push({name: 'login'})
        _this.$store.commit('$_removeStorage')
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消！'
        })
      })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.userName = JSON.parse(window.sessionStorage.user).name
    }
    this.thisPath = this.$route.path
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue